<template>
  <div>
    <section id="slider" class="hero-slider">
      <div
        class="rev-slider-wrapper fullwidthbanner-container overlay-gradient"
      >
        <!-- Start REVOLUTION SLIDER 5.4.1 fullwidth mode -->
        <div
          id="hero-slider"
          class="rev_slider fullwidthabanner"
          style="
            display: block;
            max-height: 700px;
            margin-top: 0px;
            margin-bottom: 0px;
            height: 700px;
          "
          data-version="5.4.1"
        >
          <ul>
            <!-- ===== SLIDE NR. 1 ===== -->
            <li data-transition="fade">
              <!-- MAIN IMAGE -->
              <!-- <img
                :src="require(`@/assets/images/posters/movie-collection.jpg`)"
                alt="Image"
                title="slider-bg"
                data-bgposition="center center"
                data-bgfit="cover"
                data-bgrepeat="no-repeat"
                data-bgparallax="10"
                class="rev-slidebg"
                data-no-retina=""
              /> -->
              <div
                class="slotholder"
                style="
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  z-index: 0;
                  width: 100%;
                  height: 100%;
                  backface-visibility: hidden;
                  transform: translate3d(0px, 0px, 0px);
                  visibility: inherit;
                  opacity: 1;
                "
              >
                <!--Runtime Modification - Img tag is Still Available for SEO Goals in Source - <img src="assets/images/posters/movie-collection.jpg" alt="Image" title="slider-bg" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat" data-bgparallax="10" class="rev-slidebg defaultimg" data-no-retina="">-->
                <div
                  class="tp-bgimg defaultimg"
                  data-bgcolor="undefined"
                  style="
                    background-repeat: no-repeat;

                    background-size: cover;
                    background-position: center center;
                    width: 100%;
                    height: 100%;
                    opacity: 1;
                    visibility: inherit;
                    z-index: 20;
                  "
                  :src="require(`@/assets/images/posters/movie-collection.jpg`)"
                ></div>
              </div>

              <div
                class="tp-parallax-wrap"
                style="
                  position: absolute;
                  display: block;
                  visibility: visible;
                  left: 224px;
                  top: 232px;
                  z-index: 5;
                "
              >
                <div
                  class="tp-loop-wrap"
                  style="position: absolute; display: block"
                >
                  <div
                    class="tp-mask-wrap"
                    style="
                      position: absolute;
                      display: block;
                      overflow: hidden;
                      transform: translate(90%, 100%);
                    "
                  >
                    <div
                      class="tp-caption tp-resizeme"
                      data-x="center"
                      data-hoffset=""
                      data-y="middle"
                      data-voffset="['-80','-80','-80','-80']"
                      data-responsive_offset="on"
                      data-fontsize="['60','50','40','30']"
                      data-lineheight="['60','50','40','30']"
                      data-whitespace="nowrap"
                      data-frames='[{"delay":1000,"speed":2000,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","mask":"x:0px;y:0;s:inherit;e:inherit;","to":"o:1;","ease":"Power2.easeInOut"},{"delay":"wait","speed":500,"frame":"999","to":"auto:auto;","ease":"Power3.easeInOut"}]'
                      style="
                        z-index: 5;
                        color: rgb(255, 255, 255);
                        font-weight: 900;
                        visibility: inherit;
                        transition: none 0s ease 0s;
                        text-align: inherit;
                        line-height: 47px;
                        border-width: 0px;
                        margin: 0px;
                        padding: 0px;
                        letter-spacing: 0px;
                        font-size: 47px;
                        white-space: nowrap;
                        min-height: 0px;
                        min-width: 0px;
                        max-height: none;
                        max-width: none;
                        opacity: 1;
                        transform: matrix3d(
                          1,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          1
                        );
                        transform-origin: 50% 50% 0px;
                      "
                      id="layer-209160090"
                    >
                      WELCOME TO MOVIFY
                    </div>
                  </div>
                </div>
              </div>

              <!-- LAYER NR. 2 -->
              <div
                class="tp-parallax-wrap"
                style="
                  position: absolute;
                  display: block;
                  visibility: visible;
                  left: 0px;
                  top: 304px;
                  z-index: 5;
                "
              >
                <div
                  class="tp-loop-wrap"
                  style="position: absolute; display: block"
                >
                  <div
                    class="tp-mask-wrap"
                    style="
                      position: absolute;
                      display: block;
                      overflow: hidden;
                      transform: translate(50%, 100%);
                    "
                  >
                    <div
                      class="tp-caption tp-resizeme"
                      data-x="center"
                      data-hoffset=""
                      data-y="middle"
                      data-voffset="[0]"
                      data-width="[1200, 992, 768, 98%]"
                      data-responsive_offset="on"
                      data-whitespace="nowrap"
                      data-frames='[{"delay":1000,"speed":2000,"frame":"0","from":"y:[-100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","mask":"x:0px;y:0;s:inherit;e:inherit;","to":"o:1;","ease":"Power2.easeInOut"},{"delay":"wait","speed":500,"frame":"999","to":"auto:auto;","ease":"Power3.easeInOut"}]'
                      style="
                        z-index: 5;
                        color: rgb(255, 255, 255);
                        font-weight: 900;
                        visibility: inherit;
                        transition: none 0s ease 0s;
                        text-align: inherit;
                        line-height: 23px;
                        border-width: 0px;
                        margin: 0px;
                        padding: 0px;
                        letter-spacing: 0px;
                        font-size: 15px;
                        white-space: nowrap;
                        min-height: 0px;
                        min-width: 941px;
                        max-height: none;
                        max-width: 941px;
                        opacity: 1;
                        transform: matrix3d(
                          1,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          1
                        );
                        transform-origin: 50% 50% 0px;
                      "
                      id="layer-929668131"
                    >
                      <!-- ===== START OF SEARCH FORM ===== -->
                      <form
                        id="search-form-1"
                        style="
                          transition: none 0s ease 0s;
                          text-align: inherit;
                          line-height: 22px;
                          border-width: 0px;
                          margin: 0px;
                          padding: 0px;
                          letter-spacing: 0px;
                          font-weight: 900;
                          font-size: 14px;
                        "
                      >
                        <div
                          class="row justify-content-center"
                          style="
                            transition: none 0s ease 0s;
                            text-align: inherit;
                            line-height: 21px;
                            border-width: 0px;
                            margin: 0px -14px;
                            padding: 0px;
                            letter-spacing: 0px;
                            font-weight: 900;
                            font-size: 13px;
                          "
                        >
                          <div
                            class="col-md-8 col-sm-10 col-12"
                            style="
                              transition: none 0s ease 0s;
                              text-align: inherit;
                              line-height: 20px;
                              border-width: 0px;
                              margin: 0px;
                              padding: 0px 14px;
                              letter-spacing: 0px;
                              font-weight: 900;
                              font-size: 12px;
                            "
                          >
                            <div
                              class="form-group"
                              style="
                                transition: none 0s ease 0s;
                                text-align: inherit;
                                line-height: 19px;
                                border-width: 0px;
                                margin: 0px;
                                padding: 0px;
                                letter-spacing: 0px;
                                font-weight: 900;
                                font-size: 11px;
                              "
                            >
                              <input
                                v-model="search"
                                name="search-keyword"
                                type="text"
                                id="search-keyword"
                                class="form-control"
                                placeholder="Enter Movies or Series Title"
                                style="
                                  transition: none 0s ease 0s;
                                  text-align: inherit;
                                  line-height: 23px;
                                  border-width: 1px;
                                  margin: 0px;
                                  padding: 9px 19px;
                                  letter-spacing: 0px;
                                  font-weight: 400;
                                  font-size: 15px;
                                "
                              />
                              <button
                                type="submit"
                                class="btn btn-main btn-effect"
                                @click="searchMovie"
                                style="
                                  transition: none 0s ease 0s;
                                  text-align: inherit;
                                  line-height: 33px;
                                  border-width: 0px;
                                  margin: 0px;
                                  padding: 0px;
                                  letter-spacing: 0px;
                                  font-weight: 600;
                                  font-size: 13px;
                                "
                              >
                                <i
                                  class="fa fa-search"
                                  style="
                                    transition: none 0s ease 0s;
                                    text-align: inherit;
                                    line-height: 52px;
                                    border-width: 0px;
                                    margin: 0px;
                                    padding: 0px 0px 0px 3px;
                                    letter-spacing: 0px;
                                    font-weight: 400;
                                    font-size: 21px;
                                  "
                                ></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                      <!-- ===== END OF SEARCH FORM ===== -->
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- End REVOLUTION SLIDER 5.4.1 fullwidth mode -->
      </div>
      <!-- ===== END OF REV SLIDER WRAPPER ===== -->
    </section>

    <!-- 검색 후 나타내는 페이지 -->
    <section class="top-movies2 search" :class="{ active: showMovie }">
      <div class="container">
        <div class="row" v-if="searchResult.length > 0">
          <!-- Movie List Item -->
          <div
            class="col-lg-3 col-md-6 col-sm-6 col-xs-12"
            v-for="(item, i) in searchResult"
            :key="i"
          >
            <div>
              <div class="movie-box-4">
                <div class="listing-container">
                  <!-- Movie List Image -->
                  <div class="listing-image">
                    <!-- Buttons -->
                    <div class="buttons">
                      <a
                        href="javascript:void(0)"
                        data-original-title="Rate"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        class="like"
                      >
                        <i class="icon-heart"></i>
                      </a>

                      <a
                        href="javascript:void(0)"
                        data-original-title="Share"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        class="share"
                      >
                        <i class="icon-share"></i>
                      </a>
                    </div>

                    <!-- Rating -->
                    <div class="stars">
                      <div class="rating">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star-o"></i>
                      </div>
                    </div>

                    <!-- Image -->
                    <img
                      :src="`https://image.tmdb.org/t/p/w200/${item.poster_path}`"
                      alt=""
                    />
                  </div>

                  <!-- Movie List Content -->
                  <div class="listing-content">
                    <div class="inner">
                      <h2 class="title">{{ item.title }}</h2>

                      <router-link
                        :to="`/detail/${item.id}`"
                        class="btn btn-main btn-effect"
                        >상세보기</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      search: "",
      searchResult: [],
      showMovie: false,
    };
  },
  methods: {
    async searchMovie(event) {
      event.preventDefault();

      this.showMovie = true;
      this.$emit("hideMain");
      const searchApi = await axios({
        method: "get",
        url: `https://api.themoviedb.org/3/search/movie?api_key=3d6c850fedd64a507e51cfb2335f305c&query=${this.search}&language=ko&region=kr`,
      });
      this.searchResult = searchApi.data.results;
    },
  },
};
</script>

<style scoped>
.search {
  display: none;
}

.search.active {
  display: block;
}

.col-md-6 {
  margin-bottom: 2.3%;
}
</style>
